<template>
    <div class="w-full md:w-1/3 px-2 md:p-2 md:p-8">
        <div class="sidebar">
            <div class="font-light text-4xl mb-4">
                <h2 class="text-2xl font-bold leading-tight">
                    Riepilogo
                </h2>
                <h4 class="text-xl leading-none">Codice: {{ currentImmobile.Codice }}</h4>
            </div>
            <ul class="mb-5">
                <li v-if="currentImmobile.Quartiere">
                    <span class="left">Posizione:</span>
                    <span class="right">{{ currentImmobile.ComuneWeb }}, {{ currentImmobile.Quartiere.Denominazione}}</span>
                </li>
                <li v-if="currentImmobile.TipologiaOfferta">
                    <span class="left">Tipologia:</span>
                    <span class="right">
                        {{ currentImmobile.TipologiaOfferta.Voce}}
                        <span v-if="currentImmobile.TipologiaOffertaSubordinata">{{ currentImmobile.TipologiaOffertaSubordinata.Voce}} </span>
                    </span>
                </li>
                <li v-if="currentImmobile.Piano">
                    <span class="left">Piano:</span>
                    <span class="right">{{currentImmobile.Piano.Descrizione}}</span>
                </li>
              <li v-if="currentImmobile.Ascensore">
                <span class="left">Ascensore:</span>
                <span class="right">Con ascensore</span>
              </li>
                <li v-if="contratto">
                    <span class="left">{{contratto}}:</span>
                    <span v-if="currentImmobile.TrattativaRiservata" class="right">Trattativa Riservata</span>
                    <span v-else class="right">{{prezzo|currency}}</span>
                </li>
                <li v-if="currentImmobile.MqCommerciali">
                    <span class="left">
                      Mq Commerciali:
                    </span>
                    <span class="right inline-flex items-center">
                      <span>
                        {{currentImmobile.MqCommerciali}} m<sup>2</sup>
                      </span>
 <button @click="scrollTo" v-if="currentImmobile.Consistenze" class="ml-1">
   <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
 </button>
                    </span>
                </li>
                <li v-if="currentImmobile.TipoArredamento">
                    <span class="left">Arredamento:</span>
                    <span class="right">{{currentImmobile.TipoArredamento.Voce}}</span>
                </li>
                <li v-if="currentImmobile.NLocali">
                    <span class="left">Locali:</span>
                    <span class="right">{{currentImmobile.NLocali}}</span>
                </li>
                <li v-if="currentImmobile.NCamereTotali">
                    <span class="left">Camere:</span>
                    <span class="right">{{currentImmobile.NCamereTotali}}</span>
                </li>
                <li v-if="currentImmobile.NBagniTotali">
                    <span class="left">Bagni:</span>
                    <span class="right">{{currentImmobile.NBagniTotali}}</span>
                </li>
                <li v-if="currentImmobile.TipoGarage">
                    <span class="left">Garage:</span>
                    <span v-if="currentImmobile.TipoGarage" class="right">{{currentImmobile.TipoGarage.Voce}}</span>
                </li>
                <li v-for="(caratteristica, index) in currentImmobile.Caratteristiche" :key="'c'+index">
                    <span v-if="caratteristica.Descrizione" class="left capitalize">{{caratteristica.Descrizione.Voce}}:</span>
                    <span v-else-if="caratteristica.Etichetta" class="left capitalize">{{caratteristica.Etichetta}}</span>
                    <span class="right capitalize">{{caratteristica.ValoreText}}</span>
                </li>
                <li v-if="currentImmobile.MqGarage">
                    <span class="left">Mq Garage:</span>
                    <span class="right">{{currentImmobile.MqGarage}} m<sup>2</sup></span>
                </li>
                <li v-if="currentImmobile.TipoGiardino">
                    <span class="left">Giardino:</span>
                    <span class="right">{{currentImmobile.TipoGiardino.Voce}}</span>
                </li>
                <li v-if="currentImmobile.MqGiardino">
                    <span class="left">Mq Giardino:</span>
                    <span class="right">{{currentImmobile.MqGiardino}} m<sup>2</sup></span>
                </li>
                <li v-if="currentImmobile.TipoRiscaldamento">
                    <span class="left">Riscaldamento:</span>
                    <span class="right">{{currentImmobile.TipoRiscaldamento.Voce}}</span>
                </li>
                <li v-if="currentImmobile.ClasseEnergetica">
                    <span class="left">Classe energetica:</span>
                    <span class="right">{{currentImmobile.ClasseEnergetica.Classe}}</span>
                </li>
                <li v-if="currentImmobile.EPglnren">
                    <span class="left">EPglnren:</span>
                    <span class="right">{{currentImmobile.EPglnren}} kWh/m<sup>2</sup> anno</span>
                </li>
                <li v-if="currentImmobile.EPglren">
                    <span class="left">EPglren:</span>
                    <span class="right">{{currentImmobile.EPglren}} kWh/m<sup>2</sup> anno</span>
                </li>
                <li class="ape mt-10">
                    <img :src="commons.energeticClassImage()" alt="">
                </li>
            </ul>

<!--            <div class="font-light text-4xl mb-4">
                <h2 class="text-2xl font-bold leading-none">
                    Agenzia
                </h2>
                <h4 class="text-xl leading-none">Informazioni e contatti</h4>
            </div>
            <div class="agenzia p-5 border-4 border-gray-500 rounded font-light">
                <p class="uppercase text-xl border-b mb-2 font-bold">{{ agency.Cognome }} {{ agency.Nome }}</p>
                <p>{{ agency.Indirizzo}}<span v-if="agency.Civico">, {{agency.Civico}}</span>
                    &lt;!&ndash;<span v-if="agency.ID_Cap"> - {{agency.ID_Cap}}</span>&ndash;&gt;
                </p>
                <p v-for="(telefono, index) in agency.Telefoni" :key="'t'+index">
                    <a :href="'tel:0039'+telefono.Numero">{{ telefono.Etichetta}} - {{telefono.Numero}}</a>
                </p>
                <p v-for="(email, index) in agency.Email" :key="'e'+index">
                    <a :href="'mailto:'+email.Numero">{{ email.Etichetta}} - {{email.Numero}}</a>
                </p>
            </div>-->

        </div>
    </div>
</template>
<script>
    export default {
        name: 'sidebar',
        props: {
            currentImmobile: {},
            commons: {},
            plans: {},
            agency: {}
        },
        computed: {
            contratto() {
                return this.currentImmobile.InVendita ?
                    'In Vendita':
                    'Locazione'
            },
            prezzo() {
                return this.currentImmobile.InVendita ?
                    this.currentImmobile.PrezzoVendita :
                    this.currentImmobile.PrezzoLocazione
            }
        },
      methods: {
          scrollTo() {
            this.$emit('scrollTo')
          }
      }
    }
</script>
<style lang="scss">
    .sidebar {
        ul {
            @apply -mx-2;
            li {
                @apply flex justify-between bg-gray-200 py-1 px-2 text-sm;
                &:nth-child(even) {
                    @apply bg-white
                }
                &.ape {
                    @apply p-0;
                }
            }
        }
    }
</style>
